module.exports = __webpack_public_path__ + "media/images/menu/star-74acee644775526202f0f4430b6e7d0d.svg";